import { render, staticRenderFns } from "./firewall-transactions.vue?vue&type=template&id=19e7a0e9&"
import script from "./firewall-transactions.vue?vue&type=script&lang=js&"
export * from "./firewall-transactions.vue?vue&type=script&lang=js&"
import style0 from "./firewall-transactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports